module.exports = __webpack_public_path__ + "static/coatl-d4519da7bd5886c342f1dc0088bfb811.png";